// extracted by mini-css-extract-plugin
export default {"wrap":"MicrositeTabSwitcher_wrap__c7vJ-","tab":"MicrositeTabSwitcher_tab__1dMLv","tabActive":"MicrositeTabSwitcher_tabActive__674b7"};